import { UserAPIData } from '../../../../types/growth-api';

export class UserDTO {
	readonly apiData: UserAPIData;
	readonly id: string;
	readonly display_name: string;
	readonly email: string;
	readonly first_name: string;
	readonly display_first_name: string;
	readonly lastName: string;
	readonly locale: string;
	readonly manager_id: string;
	readonly profile_pic_url: string;
	readonly user_mode: string;
	readonly username: string;
	readonly created_at: Date;
	readonly updated_at: Date;

	constructor(data: UserAPIData) {
		this.apiData = data;
		this.id = data.id;
		this.display_name = data.display_name;
		this.email = data.email;
		this.first_name = data.first_name;
		this.display_first_name = data.display_first_name;
		this.lastName = data.last_name;
		this.locale = data.locale;
		this.profile_pic_url = data.profile_pic;
		this.manager_id = data.manager_id;
		this.user_mode = data.user_mode;
		this.username = data.username;
		this.created_at = new Date(data.created_at);
		this.updated_at = new Date(data.updated_at);
	}

	// Get display name with fallbacks for empty names
	get displayFirstName(): string {
		// Try display_first_name first
		if (this.display_first_name) {
			return this.display_first_name;
		}
		
		// Fallback to first_name
		if (this.first_name) {
			return this.first_name;
		}
		
		// Fallback to username (remove email domain if present)
		if (this.username) {
			return this.username.split('@')[0];
		}
		
		// Last resort: use email prefix
		if (this.email) {
			return this.email.split('@')[0];
		}
		
		return 'Teammate';
	}
}
